// Session-scoped storage for list-screen filter memory (item #2).
//
// sessionStorage, not localStorage: filters survive in-app navigation, the
// browser back button and a page reload, but disappear when the browser/tab is
// closed — the confirmed requirement. Lives in `infrastructure` (next to
// local-storage-service) because non-UI code needs it too: the auth layer wipes
// filter memory on logout / failed refresh so a second user signing in on the
// same tab never inherits the first user's filters.
const PREFIX = "filterMemory:";
const storageKey = (screenKey) => `${PREFIX}${screenKey}`;
// Reads raw stored JSON. Returns null when nothing is stored, storage is
// unavailable (private-browsing modes throw on access) or the payload is
// corrupt — every caller treats null as "use the defaults".
export const readFilterMemory = (screenKey) => {
    try {
        const stored = window.sessionStorage.getItem(storageKey(screenKey));
        return stored ? JSON.parse(stored) : null;
    }
    catch (_a) {
        return null;
    }
};
export const writeFilterMemory = (screenKey, value) => {
    try {
        window.sessionStorage.setItem(storageKey(screenKey), JSON.stringify(value));
    }
    catch (_a) {
        // sessionStorage unavailable or over quota — filters simply don't persist.
    }
};
// Drops every filter-memory entry, leaving the rest of sessionStorage alone
// (MSAL keeps its own entries there).
export const clearAllFilterMemory = () => {
    try {
        const keys = [];
        for (let i = 0; i < window.sessionStorage.length; i++) {
            const key = window.sessionStorage.key(i);
            if (key && key.startsWith(PREFIX))
                keys.push(key);
        }
        keys.forEach((key) => window.sessionStorage.removeItem(key));
    }
    catch (_a) {
        // Nothing to clear if storage can't be read.
    }
};
